import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=9510dc44&scoped=true&"
import script from "./GroupForm.vue?vue&type=script&lang=js&"
export * from "./GroupForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=9510dc44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9510dc44",
  null
  
)

export default component.exports